<template>
<div>
<Schedule/>

</div>
</template>
<script>
import Schedule from "../../components/academic/Schedule.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   Schedule
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>